<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-800 via-green-700 to-green-600 px-4 py-12">
    <div class="max-w-md w-full">
      <!-- Card Principal -->
      <div class="bg-white rounded-2xl shadow-2xl overflow-hidden">
        <!-- Header com gradiente -->
        <div class="bg-gradient-to-r from-green-700 to-green-600 px-8 py-8 text-center">
          <div class="mb-4">
            <img 
              src="@/assets/images/logo-pdb.png" 
              alt="Logo Papo de Boleiro" 
              class="h-40 sm:h-48 mx-auto drop-shadow-lg"
            />
          </div>
          <p class="text-green-100 text-sm">
            Faça login para acessar o sistema
          </p>
        </div>

        <!-- Conteúdo -->
        <div class="px-8 py-10">
          <div class="text-center mb-8">
            <h2 class="text-xl font-semibold text-gray-800 mb-2">
              Bem-vindo!
            </h2>
            <p class="text-gray-600 text-sm">
              Entre com sua conta Google para continuar
            </p>
          </div>

          <!-- Botão de Login Google -->
          <button
            @click="auth"
            :disabled="authenticating"
            class="w-full flex items-center justify-center gap-3 px-6 py-4 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-xl shadow-md hover:bg-gray-50 hover:border-gray-400 hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-green-500 focus:ring-opacity-50 transition-all duration-200 transform hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100">
            <svg class="w-6 h-6" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span>{{ authenticating ? 'Entrando...' : 'Entrar com Google' }}</span>
          </button>

          <!-- Informação adicional -->
          <div class="mt-8 pt-6 border-t border-gray-200">
            <p class="text-center text-xs text-gray-500">
              <i class="fas fa-shield-alt mr-1"></i>
              Login seguro via Google OAuth
            </p>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="mt-8 text-center">
        <p class="text-white text-sm drop-shadow">
          <i class="fas fa-futbol mr-2"></i>
          Seu bolão de futebol favorito
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useToast } from "vue-toastification";
import SessionHelper from '@/utils/session';

export default {
  name: 'LoginView',
  setup() {
    const toast = useToast();
    return { toast }
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  },
  data() {
    return {
      authenticating: false
    }
  },
  async mounted() {
    // Aguardado para o LOGOUT não cair em cima de um login iniciado logo depois.
    await this.logout();
  },
  methods: {
    async auth() {
      if (this.authenticating) {
        return;
      }
      this.authenticating = true;

      try {
        await this.login();

        if (SessionHelper.getValidToken()) {
          this.$router.push('/');
          return;
        }

        this.toast.error('Não foi possível iniciar sua sessão. Tente novamente.');
      } catch (error) {
        console.error('Erro ao fazer login:', error);
        this.toast.error(error.message || 'Não foi possível concluir o login. Tente novamente.');
      } finally {
        this.authenticating = false;
      }
    },
    ...mapActions('user', {
      login: 'login',
      logout: 'logout'
    })
  }
}
</script>